import { Toolbar } from "@mui/material";

export default function AppBarLogo() {
    return (
        <Toolbar
            sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                padding: "0 !important",
            }}
        >
            <div
                className="bg-contain bg-no-repeat bg-right w-full h-full"
                style={{
                    backgroundImage: "url('/images/onlinehawzah.png')",
                }}
            />
        </Toolbar>
    );
}
